export default __webpack_public_path__ + "static/media/1533.00346047.png";